import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Tab } from "./Tab";
export const Tabs = ({ tabs, onTabChange, value }) => {
    if (!tabs || tabs.length === 0)
        return null;
    return (_jsx(Box, { display: "flex", alignItems: "center", gap: {
            "breakpoint.base": "spacing.12",
            "breakpoint.md": "spacing.24",
        }, role: "tablist", "aria-orientation": "horizontal", children: tabs.map((tab) => (_jsx(Tab, { name: tab.name, label: tab.label, Icon: tab.Icon, onPress: () => onTabChange(tab.name), isActive: value === tab.name }, tab.name))) }));
};
